/* ═══════════════════════════════════════════════════════════════
   Mugen Spirit — Shopify Custom Page JavaScript
   Scroll-reveal animations, navbar scroll behavior, mobile menu
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─── SCROLL REVEAL ───────────────────────────────────────── */
  function initScrollReveal() {
    var elements = document.querySelectorAll('.mugen-reveal, .mugen-reveal--left, .mugen-reveal--right');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = parseInt(entry.target.getAttribute('data-delay') || '0', 10);
          setTimeout(function () {
            entry.target.classList.add('mugen-reveal--visible');
          }, delay);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });

    elements.forEach(function (el) { observer.observe(el); });
  }

  /* ─── NAVBAR SCROLL ───────────────────────────────────────── */
  function initNavbar() {
    var nav = document.querySelector('.mugen-nav');
    if (!nav) return;

    function onScroll() {
      if (window.scrollY > 40) {
        nav.classList.add('mugen-nav--scrolled');
      } else {
        nav.classList.remove('mugen-nav--scrolled');
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ─── MOBILE MENU ─────────────────────────────────────────── */
  function initMobileMenu() {
    var btn = document.querySelector('.mugen-nav__hamburger');
    var overlay = document.querySelector('.mugen-nav__overlay');
    if (!btn || !overlay) return;

    var isOpen = false;

    btn.addEventListener('click', function () {
      isOpen = !isOpen;
      btn.classList.toggle('mugen-nav__hamburger--open', isOpen);
      overlay.classList.toggle('mugen-nav__overlay--open', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Close on link click
    overlay.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        isOpen = false;
        btn.classList.remove('mugen-nav__hamburger--open');
        overlay.classList.remove('mugen-nav__overlay--open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ─── HERO ENTRANCE ───────────────────────────────────────── */
  function initHeroEntrance() {
    var heroElements = document.querySelectorAll('[data-hero-entrance]');
    heroElements.forEach(function (el) {
      var delay = parseInt(el.getAttribute('data-hero-delay') || '0', 10);
      setTimeout(function () {
        el.style.opacity = '1';
        el.style.transform = 'none';
      }, delay);
    });
  }

  /* ─── INIT ────────────────────────────────────────────────── */
  function init() {
    initNavbar();
    initMobileMenu();
    initScrollReveal();
    // Delay hero entrance slightly for page load
    setTimeout(initHeroEntrance, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
